<template>
<v-card flat class="content ma-16">
  <v-flex class="d-flex flex-column align-start">
    <h2>Pendaftaran Masjid</h2>
    <form v-on:keyup.enter="submit">
      <v-text-field
        class="mt-4"
        outlined
        v-model.trim="$v.masjidForm.name.$model"
        :error-messages="nameError"
        label="Nama Masjid"
      ></v-text-field>
      <v-text-field
        outlined
        v-model.trim="$v.masjidForm.address.$model"
        :error-messages="addressError"
        label="Alamat Masjid"
      ></v-text-field>
      <v-text-field
        outlined
        v-model.trim="$v.masjidForm.city.$model"
        :error-messages="cityError"
        label="Kota"
      ></v-text-field>
      <v-text-field
        outlined
        v-model.trim="$v.masjidForm.province.$model"
        :error-messages="provinceError"
        label="Provinsi"
      ></v-text-field>
      <v-text-field
        outlined
        v-model="masjidForm.latitude"
        label="Latitude"
        type="number"
      ></v-text-field>
      <v-text-field
        outlined
        v-model="masjidForm.longitude"
        label="Longitude"
        type="number"
      ></v-text-field>
      <v-text-field
        label="Tahun Berdiri"
        outlined
        v-model.trim="$v.masjidForm.year_built.$model"
        :error-messages="yearError"
        type="number"
      ></v-text-field>
      <v-text-field
        outlined
        v-model="masjidForm.additional_info"
        label="Info Tambahan"
      ></v-text-field>
      <v-file-input
        v-model="file"
        accept="image/*"
        label="Foto Masjid"
        filled
        prepend-icon="mdi-camera"
      ></v-file-input>
      <v-btn @click="submit" color="primary">Daftar</v-btn>
      <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
        "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
        bagaimana kita memperbaikinya" <br />
        -Admin
      </p>

      <p v-if="isCreateError" class="mt-2 red--text text-caption error-caption">
        Maaf, terjadi kesalahan saat mendaftarkan data, mohon ulangi daftar
        kembali. ^^
      </p>
    </form>
  </v-flex>
</v-card>
</template>

<style scoped>
.v-text-field {
  width: 300px;
}
.error-caption {
  width: 350px;
}
</style>

<script>
import router from "../router";
import { required, minLength, maxValue } from "vuelidate/lib/validators";
const year = new Date().toISOString().substr(0, 4)

export default {
  data() {
    return {
      masjidForm: {
        name: "",
        address: "",
        city: "",
        province: "",
        latitude: 0,
        longitude: 0,
        year_built: 0,
        additional_info: ""
      },
      file: null,
      isFormError: false,
      isCreateError: false,
    };
  },
  validations: {
    masjidForm: {
      name: {
        required,
        minLength: minLength(3)
      },
      address: {
        required,
        minLength: minLength(5)
      },
      city: {
        required,
        minLength: minLength(4)
      },
      province: {
        required,
        minLength: minLength(4)
      },
      year_built: {
        required,
        maxYear: maxValue(year)
      }
    }
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.masjidForm.name.$dirty) return errors;
      !this.$v.masjidForm.name.minLength &&
        errors.push("Nama Masjid minimal 3 digit");
      !this.$v.masjidForm.name.required &&
        errors.push("Nama Masjid tidak boleh kosong");
      return errors;
    },
    addressError() {
      const errors = [];
      if (!this.$v.masjidForm.address.$dirty) return errors;
      !this.$v.masjidForm.address.minLength &&
        errors.push("Alamat Masjid minimal 5 digit");
      !this.$v.masjidForm.address.required &&
        errors.push("Alamat Masjid tidak boleh kosong");
      return errors;
    },
    cityError() {
      const errors = [];
      if (!this.$v.masjidForm.city.$dirty) return errors;
      !this.$v.masjidForm.city.minLength &&
        errors.push("Nama Kota minimal 4 digit");
      !this.$v.masjidForm.city.required &&
        errors.push("Nama Kota tidak boleh kosong");
      return errors;
    },
    provinceError() {
      const errors = [];
      if (!this.$v.masjidForm.province.$dirty) return errors;
      !this.$v.masjidForm.province.minLength &&
        errors.push("Nama Provinsi minimal 4 digit");
      !this.$v.masjidForm.province.required &&
        errors.push("Nama Provinsi tidak boleh kosong");
      return errors;
    },
    yearError() {
      const errors = [];
      if (!this.$v.masjidForm.year_built.$dirty) return errors;
      !this.$v.masjidForm.year_built.required &&
        errors.push("Tahun Berdiri tidak boleh kosong");
      !this.$v.masjidForm.year_built.maxYear &&
        errors.push("Tahun Berdiri tidak bisa melebihi tahun ini");
      return errors;
    },
  },
  methods: {
    submit: async function () {
      var token = this.$store.getters.getToken
      var masjidId = this.$store.getters.getMasjid
      this.isCreateError = false;
      this.$v.$touch()
      if (this.$v.masjidForm.$invalid) {
        this.isFormError = true
      }else{
        //add new masjid
        await this.axios({
          url: '/masjid',
          method: 'post',
          data: this.masjidForm,
          header: token
        })
        .then((response) => {
          masjidId = response.data.data.new.masjid_uid
          console.log(response, 'res create masjid')
        })
        .catch((error) => {
            console.log(error, 'error create masjid')
            this.isCreateError = true;
        })

        if(this.file !== null) {
          let formData = new FormData()
          formData.append("file", this.file)
          //add file images
          // console.log(this.file, '<<<<<file images')
          await this.axios({
            url: `/masjid/image/${masjidId}`,
            method: 'post',
            data: formData,
            headers: {"Content-Type": "multipart/form-data"}
          })
          .then((response) => {
            console.log(response, 'res post images')
          })
          .catch((error) => {
              console.log(error, 'error post images')
              this.isCreateError = true
          })
        }

        if(this.isCreateError === false) router.push("/admin/profile");
      }
    },
  },
};
</script>